import { adminApiRequest } from "../../utils/apiUtils";

export const AffiliateAPI = {
  getAffiliateList: () => {
    return adminApiRequest
      .get("/cafe/affiliate/list?page=0&size=99999")
      .then((res) => res);
  },
};
